import api from "../utils/api";

// signin request
export const createAccount = async (username: string, email: string, usertype: string, password: string) => {
    try {
        const res = await api.post("/api/auth/local/register", {
            username,
            email,
            password
        });

        const userData = res.data;

        // update user type after account creation because of strapi 400 error
        await api.put(`/api/users/${userData.user.id}`, {
            userType: usertype
        });

        return userData;
    } catch (e: any) {
        return {error : true, data: e.message}
    }
};

// login request
export const login = async (identifier: string, password: string) => {
    try {
        const res = await api.post("/api/auth/local", { identifier, password });
        return res;
    } catch (err: any) {
        if (err.response) {
            return { error: true, status: err.response.status, data: err.response.data };
        } else {
            return { error: true, status: 0, data: err.message };
        }
    }
};

//delete account
export const deleteAccount = async (userId: number) => {
    try {
        const res = await api.delete(`/api/users/${userId}`);
        return res;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const sendConfirmationEmail = async (email: string) => {
    try {
        const res = await api.post(`/api/auth/send-email-confirmation`, {
            email: email,
        });
        
        return res;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const confirmEmail = async (code: string) => {
    try {
        const res = await api.get(`/api/auth/email-confirmation?confirmation=${code}`);
        return res;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const sendForgotPasswordEmail = async (email: string) => {
    try {
        const res = await api.post(`/api/auth/forgot-password`, {
            email: email,
        });
        return res;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const forgotPasswordUpdate = async (code: string, newPassword: string, confirmNewPassword: string) => {
    try {
        const res = await api.post(`/api/auth/reset-password`, {
            code: code,
            password: newPassword,
            passwordConfirmation: confirmNewPassword
        });
        return res;
    } catch (e) {
        console.error(e);
        throw e;
    }
}